export default __webpack_public_path__ + "static/media/disabled_voice.61a20414.svg";